import React, { useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import i18n from "../../i18n-config";
import { CustomButton, CustomLoader, SvgContainer } from "../../components";
import theme from "../../theme/theme";
import { ADD, FILTER, LIST } from "../../assets/icons";
import GrouilleurTable from "./component/GrouilleurTable";
import GrouilleurForm from "./component/GrouilleurForm";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/state";
import { exportAsyncGrouilleur } from "../../store/features/grouilleurSlice";
import GrouilleurBaraModal from "./component/GrouilleurBaraModal";

function Grouilleur() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const grouilleurs = useSelector((state: RootState) =>
    Object.values(state.grouilleur)
  );

  const [formVisible, setFormVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [positionerModal, setPositionerModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const togglePositionerModal = () => setPositionerModal(!positionerModal);

  const onOpenForm = () => {
    setFormVisible(true);
  };

  const onCloseForm = () => {
    setFormVisible(false);
  };

  const toggleLoader = () => {
    setLoading(!loading);
  };

  const callback = (resBlob: any) => {
    const url = window.URL.createObjectURL(new Blob([resBlob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `listeGrouilleurs.xlsx`);
    // 3. Append to html page
    document.body.appendChild(link);
    // 4. Force download
    link.click();
    // 5. Clean up and remove the link
    link.parentNode?.removeChild(link);
    setLoading(false);
  };

  const onExport = () => {
    toggleLoader();
    dispatch(exportAsyncGrouilleur(callback) as any);
  };

  const positioner = (item: any) => {
    setSelectedItem(item);
    togglePositionerModal();
  };

  return (
    <Box sx={{ height: "100vh", backgroundColor: "#F9F9F9" }} p={3} pt={6}>
      <Stack direction={"row"} justifyContent="space-between" mb={3}>
        <Typography fontSize={22} fontWeight="600">
          {i18n.t("list_grouilleurs")}
        </Typography>
        <Stack direction={"row"} spacing={2}>
          <CustomButton
            title={i18n.t("grouilleur")}
            leftComponent={
              <SvgContainer svg={ADD} color={theme.colors.white} width={15} />
            }
            titleStyle={{ marginLeft: 1 }}
            onClick={onOpenForm}
          />
          <CustomButton
            title={i18n.t("filtrer_par")}
            rightComponent={
              <SvgContainer
                svg={FILTER}
                color={theme.colors.white}
                width={15}
              />
            }
            titleStyle={{ marginRight: 1 }}
            rootStyle={{ backgroundColor: theme.colors.black, height: 45 }}
          />
          <CustomButton
            title={i18n.t("exporter_liste")}
            leftComponent={
              <SvgContainer svg={LIST} color={theme.colors.white} width={15} />
            }
            titleStyle={{ marginLeft: 1 }}
            rootStyle={{ backgroundColor: "#3D423F", height: 45 }}
            onClick={onExport}
          />
        </Stack>
      </Stack>
      <GrouilleurTable data={grouilleurs} positioner={positioner} />
      {formVisible ? (
        <GrouilleurForm open={formVisible} onClose={onCloseForm} />
      ) : null}
      <CustomLoader open={loading} handleClose={toggleLoader} />
      <GrouilleurBaraModal open={positionerModal} onClose={togglePositionerModal} />
    </Box>
  );
}

export default Grouilleur;
